import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../App";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Lock, User } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_pos-register-pro/artifacts/r59p7j84_PHOTO-2025-11-25-13-33-44.jpg";

export default function LoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login, user } = useAuth();
  const navigate = useNavigate();

  // Redirect if already logged in
  if (user) {
    navigate("/", { replace: true });
    return null;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const success = await login(username, password);
    setLoading(false);
    if (success) {
      navigate("/", { replace: true });
    }
  };

  return (
    <div 
      className="min-h-screen flex items-center justify-center p-4"
      style={{ background: "linear-gradient(135deg, #1e293b 0%, #0f172a 100%)" }}
      data-testid="login-page"
    >
      <Card className="w-full max-w-md shadow-2xl border-0">
        <CardHeader className="text-center pb-2">
          <div className="flex justify-center mb-4">
            <img 
              src={LOGO_URL} 
              alt="Nimsi's Logo" 
              className="w-32 h-32 object-contain rounded-lg shadow-lg"
            />
          </div>
          <CardTitle className="text-2xl font-bold text-slate-800">
            Nimsi's Stationery
          </CardTitle>
          <p className="text-slate-500 text-sm mt-1">& Home Supply</p>
          <p className="text-slate-400 text-xs mt-2">San Narciso, Belize</p>
        </CardHeader>
        <CardContent className="pt-4">
          <form onSubmit={handleSubmit} className="space-y-5">
            <div className="space-y-2">
              <Label htmlFor="username" className="text-slate-700 font-medium">
                Username
              </Label>
              <div className="relative">
                <User className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" />
                <Input
                  id="username"
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  className="pl-10 h-12"
                  placeholder="Enter username"
                  required
                  data-testid="username-input"
                />
              </div>
            </div>
            <div className="space-y-2">
              <Label htmlFor="password" className="text-slate-700 font-medium">
                Password
              </Label>
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" />
                <Input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="pl-10 h-12"
                  placeholder="Enter password"
                  required
                  data-testid="password-input"
                />
              </div>
            </div>
            <Button
              type="submit"
              className="w-full h-12 text-base font-semibold bg-blue-600 hover:bg-blue-700"
              disabled={loading}
              data-testid="login-button"
            >
              {loading ? (
                <span className="flex items-center gap-2">
                  <span className="loading-spinner" />
                  Signing in...
                </span>
              ) : (
                "Sign In"
              )}
            </Button>
          </form>
          <div className="mt-6 pt-4 border-t border-slate-100">
            <p className="text-center text-sm text-slate-400">
              POS System v1.0
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
